<section class="support-section">
  <div class="bg-svg-container">
    <svg width="266" height="518" viewBox="0 0 266 518" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.25" d="M265.694 401.776V518H171.121V421.325L-53.5493 0H55.6513L265.694 401.776Z" fill="#3399FF"/>
    </svg>
    <svg style="margin-left: 133px;" xmlns="http://www.w3.org/2000/svg" width="298" height="518" viewBox="0 0 298 518" fill="none">
      <path d="M297.032 368.708V518H202.458V388.257L0 0H109.201L297.032 368.708Z" fill="#3399FF" fill-opacity="0.25"/>
    </svg>
    <svg style="margin-left: 321px;" xmlns="http://www.w3.org/2000/svg" width="276" height="518" viewBox="0 0 276 518" fill="none">
      <path d="M0 0H109.201L275.207 334.894V518H180.634V354.119L0 0Z" fill="#3399FF" fill-opacity="0.25"/>
    </svg>
  </div>
  <h2 class="section-title">Toujours là pour vous</h2>
  <div class="content-wrapper">
    <div class="images-container">
      <img src="assets/img/Supportenligne.webp" fetchpriority="high" alt="Support en ligne" class="img-top">
      <img src="assets/img/AgentAppel.webp" fetchpriority="high" alt="Agent au téléphone" class="img-bottom">
    </div>
    <div class="text-container">
      <h3>Une question ? On s'en occupe</h3>
      <p class="subtitle">Rapide. Humain. Efficace.</p>
      <p>Un service client toujours à vos côtés, prêt à vous accompagner à chaque étape.</p>
      <div class="trustpilot-box">
        <span class="trustpilot-title">Trustpilot</span>
        <div class="trustpilot-rating">
          <div class="stars">
            <div class="star-box">★</div>
            <div class="star-box">★</div>
            <div class="star-box">★</div>
            <div class="star-box">★</div>
            <div class="star-box half">★</div>
          </div>
          <span>4,5 <small>• 6 244 avis</small></span>
        </div>
      </div>
    </div>
  </div>
</section>